/*
 * File: ZoomInfoHome.tsx
 * Project: a-a
 * File Created: Thursday, 23rd October 2025 10:00:12 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Friday, 14th November 2025 11:49:33 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */

import { Box, Typography } from '@mui/material';
import CustomTab from '../../shared/CustomTab/CustomTab';
import { useEffect, useState } from 'react';
import ZoomList from './ZoomList/ZoomList';
import CustomCard from '../../shared/CustomCard/CustomCard';
import { Link } from 'react-router-dom';
import zeplinColor from '../../../theme/Color';
import styles from './ZoomInfoHome.module.css';
import { ZoomInfoService } from '../../../service/zoominfo.service';
import CustomAlert from '../../shared/CustomAlert/CustomAlert';
import CustomAlertContain from '../../shared/CustomAlert/CustomAlertContain';

const ZoomInfoHome = () => {
  const [value, setValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>(null);
  const [targetData, setTargetData] = useState<any>(null);
  const [suggestionData, setSuggestionData] = useState<any>(null);
  const [alert, setAlert] = useState(false);
  const [page, setPage] = useState(1);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const handleClose = () => {
    setAlert(false);
  };
  const getUpdates = async (refresh = false) => {
    try {
      setLoading(true);
      const res = await ZoomInfoService.getTopUpdates(refresh ? 1 : page || 1);
      console.log(res);
      setData((prev: any) =>
        prev && !refresh ? { ...prev, items: [...prev?.items, ...res?.items] } : { ...res },
      );
      setPage((prev) => prev + 1);
    } catch (err) {
      console.log(err, 'zoominfo-home, getUpdates');
    } finally {
      setLoading(false);
    }
  };

  const getTarget = async (refresh = false) => {
    try {
      setLoading(true);
      const res = await ZoomInfoService.getTargetAccounts(refresh ? 1 : page);
      console.log({ items: res?.data?.companies?.map((val: any) => val?.companyData) });
      setTargetData((prev: any) =>
        prev && !refresh
          ? {
              ...prev,
              items: [
                ...prev?.items,
                ...{ items: res?.data?.companies?.map((val: any) => val?.companyData) }?.items,
              ],
              total: res?.data?.pagination?.total,
            }
          : {
              items: res?.data?.companies?.map((val: any) => val?.companyData),
              total: res?.data?.pagination?.total,
            },
      );
      setPage((prev) => prev + 1);
    } catch (err) {
      console.log(err, 'zoominfo-home, getUpdates');
    } finally {
      setLoading(false);
    }
  };
  const getSuggestion = async (refresh = false) => {
    try {
      setLoading(true);
      const res = await ZoomInfoService.getSuggestion(refresh ? 1 : page);
      console.log(res);
      setSuggestionData((prev: any) =>
        refresh ? res : { ...prev, items: [...prev.items, ...res.items] },
      );
      setPage((prev) => prev + 1);
    } catch (err) {
      console.log(err, 'zoominfo-home, getUpdates');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const handleAlert = (e: CustomEvent) => {
      setAlert(e.detail.value);
    };
    window.addEventListener('zoomInfo-targetAdded', handleAlert as EventListener);

    // Cleanup
    return () => {
      window.removeEventListener('zoomInfo-targetAdded', handleAlert as EventListener);
    };
  }, []);
  useEffect(() => {
    value === 0 && getUpdates(true);
    value === 1 && getTarget(true);
    value === 2 && getSuggestion(true);
    setPage(1);
  }, [value]);
  const ClientTabs = [
    {
      label: 'Top Updates',
      id: 1,
      isHidden: value !== 0,
      Component: (
        <Box>
          <ZoomList category='updates' loading={loading} data={data} getData={getUpdates} />
        </Box>
      ),
    },
    {
      label: `Target Accounts ${targetData ? '(' + targetData?.total + ')' : ''}`,
      id: 2,
      isHidden: value !== 1,
      Component: (
        <Box>
          <ZoomList category='accounts' loading={loading} data={targetData} getData={getTarget} />
        </Box>
      ),
    },
    {
      label: 'Suggestions (50)',
      id: 3,
      isHidden: value !== 2,
      Component: (
        <Box>
          <ZoomList
            category='suggestion'
            loading={loading}
            data={suggestionData}
            getData={getSuggestion}
          />
        </Box>
      ),
    },
  ];
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <Box
        sx={{
          padding: '24px 1.5rem 0rem 1.5rem',
          // height: '75vh',
          // display: 'flex',
          // flexDirection: 'column',
          // flex: 1,
          position: 'relative',
          overflow: 'auto',
        }}
      >
        {' '}
        <CustomTab tabs={ClientTabs} handleChange={handleChange} value={value} />
        <Box
          sx={{
            position: 'absolute',
            top: '1.5rem',
            right: '1.5rem',
            display: 'flex',
            gap: '16px',
          }}
        >
          {' '}
          <Link
            to={'https://login.zoominfo.com/'}
            style={{ color: zeplinColor.BasicBlack, textDecoration: 'none' }}
            target='_blank'
            rel='noopener noreferrer'
          >
            <CustomCard
              styles={{
                borderRadius: '50px',
                padding: { xs: '8px 8px 8px 14px', xl: '10px 10px 10px 16px' },
                backgroundColor: zeplinColor.Neutral1,
                border: `1px solid ${zeplinColor.Neutral6}`,
                display: 'flex',
                gap: '8px',
                // flexDirection: 'column',
                alignItems: 'flex-end',
                justifyContent: 'space-between',
                cursor: 'pointer',
              }}
            >
              <Typography variant='responsiveBody3'>ZoomInfo</Typography>
              <img src='/assets/link-2.svg' className={styles['zoomLink']} />
            </CustomCard>
          </Link>
        </Box>
      </Box>
      <CustomAlert
        open={alert ? true : false}
        handleClose={handleClose}
        message={
          <CustomAlertContain
            alertIcon={
              alert ? (
                <img src='/assets/checkmark-green.png' width={24} height={24} />
              ) : (
                <img src='/assets/error.svg' width={24} height={24} />
              )
            }
            alert={'Added successfully to target accounts'}
          />
        }
        error={false}
      />
    </Box>
  );
};

export default ZoomInfoHome;
